import { useCallback, useSyncExternalStore } from 'react';
import {
  i18nService,
  t,
  type Language,
  type TranslateParams,
} from './i18nService';
import type { I18nKey } from './locales';

export const useI18n = () => {
  const language = useSyncExternalStore(
    i18nService.subscribe,
    i18nService.getSnapshot,
    i18nService.getServerSnapshot,
  );

  const changeLanguage = useCallback((nextLanguage: Language) => {
    i18nService.setLanguage(nextLanguage);
  }, []);

  const translate = useCallback(
    (key: I18nKey, params?: TranslateParams) => i18nService.t(key, params),
    [language],
  );

  return {
    language,
    locale: language,
    changeLanguage,
    t: translate,
  };
};

export { t };
